export default __webpack_public_path__ + "static/bognal-2aef34fa25fe0c5a395eb2460d6513e0.png";